const SELECTOR_SINGLE_SCREEN_VIEW_SCROLLABLE = '.main-wrapper';
const CLASS_SCROLL_LOCK = 'scroll-lock';

export default class LayoutHelper {
  static get viewRoots(): HTMLElement[] {
    return [document.body];
  }

  static get scrollableViewRoots(): HTMLElement[] {
    const scrollableRoot = document.querySelector(SELECTOR_SINGLE_SCREEN_VIEW_SCROLLABLE);
    if (scrollableRoot instanceof HTMLElement) {
      return [scrollableRoot];
    }

    throw new Error('Scrollable root was not found');
  }

  public static setPageScroll(isDisable: boolean): void {
    isDisable
      ? this.viewRoots.forEach((root) => root.classList.add(CLASS_SCROLL_LOCK))
      : this.viewRoots.forEach((root) => root.classList.remove(CLASS_SCROLL_LOCK));
  }
}
